import React from 'react';
export default function InlineSpinner({ size = 18 }) {
  return <span className="spinner spinner-sm" style={{ width: size, height: size }} />;
}
